export default function sortFilters(allFilters, routeFilters) {
  if (!routeFilters || !routeFilters.length) return []

  const result = []

  groupLabel: for (const group of allFilters) {
    for (const item of group.data) {
      const index = routeFilters.indexOf(item.slug)
      if (index > -1) {
        result.push(item.slug)
        routeFilters.splice(index, 1)

        if (!routeFilters.length) {
          break groupLabel
        }
      }
    }
  }

  return result
}
